import { ListRowItem } from 'components/ListRowItem'
import { ListRowItemImage } from 'components/ListRowItem/Image'
import Title from 'components/ListRowItem/Title'
import { isKeyInSchemaModelUtil } from 'models/utils/is-key-in-schema'
import { getRelativeUrlReduxUtil } from 'modules/redux/utils/get-url'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import PropTypes from 'prop-types'
import React from 'react'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { logEventWithPrefixAnalyticsUtil } from 'modules/analytics/utils/log-event-with-prefix/index.js'

const ANALYTICS_EVENTS = {
  VIEW_SECTION_ITEM: 'VIEW_SECTION_ITEM'
}

/**
 * @param instance
 * @param itemElement
 * @param style
 * @param isHorizontal
 * @param index
 * @param hasFixedWidth
 * @param analyticEventPrefix
 * @param analyticEventElementName
 * @returns {JSX.Element}
 * @constructor
 */
export default function SectionItem ({
  instance,
  itemElement,
  style,
  isHorizontal,
  index,
  hasFixedWidth,
  analyticEventPrefix
}) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)

  const handleClick = () => {
    logEventWithPrefixAnalyticsUtil(analyticEventPrefix, ANALYTICS_EVENTS.VIEW_SECTION_ITEM)
  }

  const getUrl = () => {
    return getRelativeUrlReduxUtil(instance)
  }

  const getImage = () => {
    return getValueReduxUtil(
      instance,
      'img'
    )
  }

  const renderCustomItem = () => {
    if (!itemElement) {
      return
    }

    return itemElement
  }

  const renderImage = () => {
    if (itemElement) {
      return
    }

    const image = getImage()
    if (!image) {
      return
    }

    return (
      <ListRowItemImage
        title={getValueReduxUtil(
          instance,
          'title'
        )}
        shouldLazyLoad
        image={image}
        url={getUrl()}
        isHorizontal={isHorizontal}
        width={getWidth()}
      />
    )
  }

  const renderTitle = () => {
    const value = getValueReduxUtil(
      instance,
      'title'
    )
    if (itemElement ||
      !value) {
      return
    }
    const style = {}
    if (!getImage()) {
      style.marginTop =
        0
    }
    return (
      <Title
        value={value}
        url={getUrl()}
        style={style}
      />
    )
  }

  const getWidth = () => {
    let width
    if (hasFixedWidth &&
      isSmallScreen) {
      width =
        '13.88em'
    } else if (hasFixedWidth) {
      width =
        '22.22em'
    }
    return width
  }

  let isTranslucent
  if (instance &&
    isKeyInSchemaModelUtil(
      instance.className,
      'publishedAt'
    )) {
    isTranslucent =
      !getValueReduxUtil(
        instance,
        'publishedAt'
      )
  }

  const styleToPass = {
    padding: 0,
    opacity: isTranslucent
      ? '0.5'
      : '1',
    width: getWidth(),
    overflow: 'hidden',
    textAlign: 'left',
    ...(
      style ||
      {}
    )
  }

  return (
    <ListRowItem
      ml={index === 0 ? 3 : 0}
      onClick={handleClick}
      style={styleToPass}
    >
      {renderCustomItem()}
      {renderImage()}
      {renderTitle()}
    </ListRowItem>
  )
}

SectionItem.propTypes =
  {
    instance: PropTypes.object.isRequired,
    itemElement: PropTypes.element,
    style: PropTypes.object,
    isHorizontal: PropTypes.bool,
    index: PropTypes.number,
    hasFixedWidth: PropTypes.bool
  }
